<template>
  <div class="authorizationrecord pointer">
    <NavBar title="授权记录" />
    <div class="main" v-if="!showDialog && recordlist.length >= 0">
      <div class="jlcard" v-for="(item, index) in recordlist" :key="index">
        <div class="jlcr_top">
          <p>设备名称：{{ item.instanceName }}</p>
          <span>{{
            item.authorizeWayStatus == 0 ? "授权他人" : "被授权"
          }}</span>
        </div>
        <div class="jlcr_main">
          <p>授权开始时间：{{ item.startTime }}</p>
          <p>授权结束时间：{{ item.endTime }}</p>
          <p>授权状态：{{ item.authorizeStatusShow }}</p>
          <p>授权人账号：{{ item.phoneNumber }}</p>
        </div>
        <button
          v-if="item.authorizeStatus == 0"
          class="qxsq"
          @click="quxiaomanage(item)"
        >
          取消授权
        </button>
      </div>
    </div>
    <van-empty
      v-if="!showDialog && recordlist.length <= 0"
      class="custom-image"
      :image="require('@/assets/imgs/empty.png')"
      description="暂时没有授权记录哦！"
    />
    <Loading v-model="showDialog" text="加载中...">
      <!-- <div>中间内容</div> -->
    </Loading>
  </div>
</template>

<script>
import { authorizerecordlist, authorizemanage } from "@/api/instance";
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import Loading from "@/components/publicDialog/Loading.vue";
export default {
  name: "Authorizationrecord",
  components: {
    NavBar,
    Loading,
  },
  data() {
    return {
      recordlist: [],
      showDialog: true,
    };
  },

  mounted() {
    this.getauthorizerecordlist();
  },

  methods: {
    // 获取授权记录列表
    async getauthorizerecordlist() {
      await authorizerecordlist().then((res) => {
        if (res.code == 200) {
          this.recordlist = res.data;
          this.showDialog = false;
        } else {
          Toast(res.msg);
        }
      });
    },
    // 取消授权
    async quxiaomanage(em) {
      let data = {
        id: em.id,
      };
      await authorizemanage(data).then((res) => {
        if (res.code == 200) {
          Toast("取消授权成功！");
          this.getauthorizerecordlist();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.authorizationrecord {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 10px 16px 16px 16px;
  .jlcard {
    margin-bottom: 12px;
    height: 178px;
    background: #fff;
    border-radius: 8px;
    position: relative;
    .jlcr_top {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      border-bottom: 1px solid rgb(239, 239, 239);
      p {
        margin: 0;
        flex: 1;
        color: rgb(30, 33, 51);
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0px;
        text-align: left;
      }
      span {
        color: #886df3;
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;
        text-align: right;
      }
    }
    .jlcr_main {
      text-align: left;
      p {
        margin: 10px 0 0 20px;
        height: 20px;
        color: rgb(30, 33, 51);
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
      }
    }
    .qxsq {
      width: 84px;
      height: 30px;
      font-size: 15px;
      color: #886df3;
      background: #fff;
      border: 1px solid #886df3;
      border-radius: 16px;
      position: absolute;
      right: 16px;
      bottom: 16px;
    }
  }
}
.mains {
  margin-top: 200px;
  img {
    width: 120px;
    height: 120px;
  }
  p {
    margin: 0;
    height: 22px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
}
</style>